const topMainPeople = () => {

  const pageTop = document.getElementById('pageTop');
  if (pageTop) {

    let secMain = document.getElementById('jsSecMain');
    let jsPeople = secMain.querySelectorAll('.js-people-box');
    jsPeople.forEach(element => {

    });

    // console.log(jsPeople);

    // let arrayMoveRdown = [
    //   jsPeopleI[1],
    //   jsPeopleI[5],
    //   jsPeopleI[11],
    //   jsPeopleI[12],
    //   jsPeopleI[13],
    //   jsPeopleI[15],
    // ]
    // let arrayMoveRup = [

    // ]
    // let arrayMoveLdown = [
    //   jsPeopleI[2],
    //   jsPeopleI[3],
    //   jsPeopleI[4],
    //   jsPeopleI[14],
    // ]
    // let arrayMoveLup = [
    //   jsPeopleI[8],
    // ]
    // let arrayMoveInf = [
    //   jsPeopleI[0],
    //   jsPeopleI[6],
    //   jsPeopleI[7],
    //   jsPeopleI[9],
    //   jsPeopleI[10],
    // ]

    const moveStart = (elem) => {
      let i = elem.querySelector('i');
      i.className = 'act'
    }
    const moveStop = (elem) => {
      let i = elem.querySelector('i');
      i.classList.add('stop');
    }
    const moveReset = (elem) => {
      elem.classList.remove('act')
      let i = elem.querySelector('i');
      setTimeout(() => {
        i.classList.remove('act')
      }, 1000)
    }

    const moveLoop = (elem, time, func) => {
      let diff = 3000
      elem.classList.add('act')
      moveStart(elem)
      setTimeout(() => {
        moveStop(elem)
      }, time)
      setTimeout(() => {
        moveReset(elem)
      }, time + diff)
      setTimeout(() => {
        func()
      }, time + diff * 2)
    }


    const people1 = () => {
      let elem = jsPeople[1]
      let time = 24000
      moveLoop(elem, time, people1)
    }
    people1()

    const people2 = () => {
      let elem = jsPeople[2]
      let time = 20000
      moveLoop(elem, time, people2)
    }
    people2()

    const people3 = () => {
      let elem = jsPeople[3]
      let time = 34000
      moveLoop(elem, time, people3)
    }
    people3()

    const people4 = () => {
      let elem = jsPeople[4]
      let time = 8000
      moveLoop(elem, time, people4)
    }
    people4()

    const people5 = () => {
      let elem = jsPeople[5]
      let time = 40000
      moveLoop(elem, time, people5)
    }
    people5()

    const people8 = () => {
      let elem = jsPeople[8]
      let time = 28000
      moveLoop(elem, time, people8)
    }
    people8()

    const people11 = () => {
      let elem = jsPeople[11]
      let time = 24000
      moveLoop(elem, time, people11)
    }
    people11()

    const people12 = () => {
      let elem = jsPeople[12]
      let time = 26000
      moveLoop(elem, time, people12)
    }
    people12()

    const people13 = () => {
      let elem = jsPeople[13]
      let time = 40000
      moveLoop(elem, time, people13)
    }
    people13()

    const people14 = () => {
      let elem = jsPeople[14]
      let time = 90000
      moveLoop(elem, time, people14)
    }
    people14()

    const people15 = () => {
      let elem = jsPeople[15]
      let time = 60000
      moveLoop(elem, time, people15)
    }
    people15()


  }

}
export default topMainPeople;